import React from 'react';
import { SectionSelectorOptionsContainer, SectionSelectorTitle, StyledSectionSelectorContainer } from './styled.sectionSelector';
import { Checkbox } from '../../../common/sharedComponents/Checkbox';
import { ISectionSelector } from '../../../@types/sectionSelector';
import { Headline4 } from '../../../common/typography';

export function SectionSelector ({title, options}: ISectionSelector) {
  return (
    <StyledSectionSelectorContainer>
      <SectionSelectorTitle>
          <Headline4 ellipsis={true}>{title}</Headline4>
      </SectionSelectorTitle>
      <SectionSelectorOptionsContainer>
        {options.map((option, index) => {
          return <Checkbox
            key={option.label + index}
            label={option.label}
            onClick={option.optionCallback}
            checked={option.checked}
            disabled={option.disabled}
          />;
        })}
      </SectionSelectorOptionsContainer>
    </StyledSectionSelectorContainer>
  );
}
